import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import Loading from "../../general/Loading";
import Unauthorized from "../../general/Unauthorized";
import Swal from 'sweetalert2';

function EditarUsuarioSispro() {
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Estados del formulario
    const [nombre, setNombre] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('CC');
    const [identificacion, setIdentificacion] = useState('');
    const [password, setPassword] = useState('');
    const [nit, setNit] = useState('');
    const [usersId, setUsersId] = useState('');
    const [activo, setActivo] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
    
    const [errorlist, setErrorlist] = useState({});
    const [guardando, setGuardando] = useState(false);

    let history = useHistory();

    useEffect(() => {
        let userdata = [];
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Validación de permisos
        const tienePermiso = userdata.up && userdata.up.includes('gestionarUsuariosSispro');
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoading(false);
            return;
        }

        setHasPermission(true);

        // Obtener datos del cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                    cargarUsuarioSispro(id);
                    // Cargar usuarios del mismo cliente
                    cargarUsuarios(userdata.user_id);
                }
            })
            .catch(error => {
                console.log('Error:', error);
                setLoading(false);
            });
    }, [id]);

    const cargarUsuarios = (userId) => {
        axios.get('/usuarios?uid=' + userId)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar usuarios:', error);
            });
    };

    const cargarUsuarioSispro = (usuarioId) => {
        let userdata = [];
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: usuarioId
            }
        };

        axios.get('/sispro-user', config)
            .then(response => {
                const usuario = response.data;
                setNombre(usuario.nombre);
                setTipoDocumento(usuario.tipo_documento);
                setIdentificacion(usuario.identificacion);
                setNit(usuario.nit || '');
                setUsersId(usuario.users_id || '');
                setActivo(usuario.activo);
                setLoading(false);
            })
            .catch(error => {
                console.log('Error al cargar usuario SISPRO:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo cargar el usuario SISPRO'
                });
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrorlist({});
        setGuardando(true);

        const data = {
            nombre: nombre,
            tipo_documento: tipoDocumento,
            identificacion: identificacion,
            nit: nit || identificacion, // Si NIT está vacío, usar identificación
            activo: activo
        };

        // Solo agregar users_id si tiene valor
        if (usersId && usersId !== '') {
            data.users_id = parseInt(usersId);
        }

        // Solo incluir password si se proporcionó uno nuevo
        if (password) {
            data.password = password;
        }

        axios.put(`/sispro-user/${id}`, data)
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Usuario actualizado',
                    text: 'El usuario SISPRO se ha actualizado correctamente',
                    timer: 2000,
                    showConfirmButton: false
                });
                
                history.push('/usuarios-sispro');
            })
            .catch(error => {
                setGuardando(false);
                if (error.response && error.response.status === 422) {
                    setErrorlist(error.response.data.errors);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo actualizar el usuario SISPRO'
                    });
                }
            });
    };

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn || loading) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="settings" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item"><Link to="/personal-proveedores">Personal y Proveedores</Link></li>
                                    <li className="breadcrumb-item"><Link to="/usuarios-sispro">Usuarios SISPRO</Link></li>
                                    <li className="breadcrumb-item active">Editar Usuario</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Editar Usuario SISPRO</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-10">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Información del Usuario SISPRO
                                        </h3>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="card-body">
                                            
                                            <div className="form-group">
                                                <label htmlFor="nombre">Nombre Descriptivo *</label>
                                                <input
                                                    type="text"
                                                    id="nombre"
                                                    className="form-control"
                                                    value={nombre}
                                                    onChange={(e) => setNombre(e.target.value)}
                                                    placeholder="Ej: Usuario Principal SISPRO"
                                                    required
                                                />
                                                <small className="form-text text-muted">
                                                    Nombre para identificar este usuario en el sistema
                                                </small>
                                                {errorlist.nombre && (
                                                    <small className="text-danger">{errorlist.nombre}</small>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="tipo_documento">Tipo de Documento *</label>
                                                        <select
                                                            id="tipo_documento"
                                                            className="form-control"
                                                            value={tipoDocumento}
                                                            onChange={(e) => setTipoDocumento(e.target.value)}
                                                            required
                                                        >
                                                            <option value="CC">Cédula de Ciudadanía</option>
                                                            <option value="CE">Cédula de Extranjería</option>
                                                            <option value="NIT">NIT</option>
                                                            <option value="TI">Tarjeta de Identidad</option>
                                                            <option value="PA">Pasaporte</option>
                                                        </select>
                                                        {errorlist.tipo_documento && (
                                                            <small className="text-danger">{errorlist.tipo_documento}</small>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="identificacion">Número de Identificación *</label>
                                                        <input
                                                            type="text"
                                                            id="identificacion"
                                                            className="form-control"
                                                            value={identificacion}
                                                            onChange={(e) => setIdentificacion(e.target.value)}
                                                            placeholder="Ingrese el número de identificación"
                                                            required
                                                        />
                                                        {errorlist.identificacion && (
                                                            <small className="text-danger">{errorlist.identificacion}</small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="password">Nueva Contraseña SISPRO (opcional)</label>
                                                <div className="input-group">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        id="password"
                                                        className="form-control"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        placeholder="Dejar vacío para mantener la actual"
                                                    />
                                                    <div className="input-group-append">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        >
                                                            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <small className="form-text text-muted">
                                                    Solo ingrese una contraseña si desea cambiarla
                                                </small>
                                                {errorlist.password && (
                                                    <small className="text-danger">{errorlist.password}</small>
                                                )}
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="nit">NIT (Opcional)</label>
                                                <input
                                                    type="text"
                                                    id="nit"
                                                    className="form-control"
                                                    value={nit}
                                                    onChange={(e) => setNit(e.target.value)}
                                                    placeholder="Ingrese el NIT si aplica"
                                                />
                                                <small className="form-text text-muted">
                                                    Si se deja vacío, se usará el número de identificación
                                                </small>
                                                {errorlist.nit && (
                                                    <small className="text-danger">{errorlist.nit}</small>
                                                )}
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="usersId">Usuario Responsable (Opcional)</label>
                                                <select
                                                    id="usersId"
                                                    className="form-control"
                                                    value={usersId}
                                                    onChange={(e) => setUsersId(e.target.value)}
                                                >
                                                    <option value="">Seleccionar Usuario</option>
                                                    {usuarios.map((usuario) => (
                                                        <option key={usuario.id} value={usuario.id}>
                                                            {usuario.name} {usuario.lastname}
                                                        </option>
                                                    ))}
                                                </select>
                                                <small className="form-text text-muted">
                                                    Usuario que gestiona este usuario SISPRO
                                                </small>
                                                {errorlist.users_id && (
                                                    <small className="text-danger">{errorlist.users_id}</small>
                                                )}
                                            </div>

                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="activo"
                                                        checked={activo === 1}
                                                        onChange={(e) => setActivo(e.target.checked ? 1 : 0)}
                                                    />
                                                    <label className="custom-control-label" htmlFor="activo">
                                                        Usuario activo
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="alert alert-info">
                                                <i className="fas fa-info-circle"></i> Este usuario se utilizará para el envío de RIPS al sistema SISPRO.
                                            </div>

                                        </div>
                                        <div className="card-footer">
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary"
                                                disabled={guardando}
                                            >
                                                {guardando ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm mr-2"></span>
                                                        Guardando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save mr-2"></i>
                                                        Actualizar
                                                    </>
                                                )}
                                            </button>
                                            {' '}
                                            <Link to="/usuarios-sispro" className="btn btn-secondary">
                                                <i className="fas fa-arrow-left mr-2"></i>
                                                Cancelar
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default EditarUsuarioSispro;
